import { render } from "./AgentShareDialog.vue?vue&type=template&id=30900ed2&ts=true"
import script from "./AgentShareDialog.vue?vue&type=script&lang=ts"
export * from "./AgentShareDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__